"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setNonce = exports.rmNonce = exports.matchNonce = exports.generateNonce = void 0;
var _crypto = require("./utils/crypto.js");
var _session = require("./session.js");
var _errorCode = require("./error/error-code.js");
var _validation = require("./utils/validation.js");
var _ValidationError = _interopRequireDefault(require("./error/ValidationError.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var generateNonce = function generateNonce() {
  var charset = '0123456789ABCDEFGHIJKLMNOPQRSTUVXYZabcdefghijklmnopqrstuvwxyz';
  var charsetLength = charset.length;
  var length = 16;
  var result = '';
  while (length > 0) {
    var bytes = new Uint8Array(16);
    var random = (0, _crypto.getCrypto)().getRandomValues(bytes);
    random.forEach(function (c) {
      if (length === 0) {
        return undefined;
      }
      var charsetIndex = c % charsetLength;
      result += charset[charsetIndex];
      length--;
    });
  }
  return result;
};
exports.generateNonce = generateNonce;
var matchNonce = function matchNonce(cacheName) {
  return function (nonceValueToMatch) {
    var challengeStore = new Set((0, _session.getItemJSON)(cacheName)) || new Set();
    return challengeStore.has(nonceValueToMatch);
  };
};
exports.matchNonce = matchNonce;
var rmNonce = function rmNonce(cacheName) {
  return function (nonceValue) {
    var challengeStore = new Set((0, _session.getItemJSON)(cacheName)) || new Set();
    if (!challengeStore.has(nonceValue)) {
      console.warn('challenge not present');
      return undefined;
    }
    challengeStore["delete"](nonceValue);
    (0, _session.setItem)(cacheName)(JSON.stringify(_toConsumableArray(challengeStore)));
    return undefined;
  };
};
exports.rmNonce = rmNonce;
var setNonce = function setNonce(cacheName) {
  return function (nonceValue) {
    if (!(0, _validation.isStringWithLength)(nonceValue)) {
      throw new _ValidationError["default"](_errorCode.VALIDATION, 'Nonce value is not valid');
    }
    var currentStore = new Set((0, _session.getItemJSON)(cacheName)) || new Set();
    currentStore.add(nonceValue);
    (0, _session.setItem)(cacheName)(JSON.stringify(_toConsumableArray(currentStore)));
  };
};
exports.setNonce = setNonce;